export const FallBackImage = 'https://tecxprts3qa.s3.amazonaws.com/1707461492528user.png';
